export default __webpack_public_path__ + "static/media/inst-white.82631b18.svg";